import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import logo from "./assets/logo.png";
import "./Navbar.css";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (!element) return;

    const headerOffset = 80;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition =
      elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({ top: offsetPosition, behavior: "smooth" });
  };

  const handleScroll = (e, id) => {
    e.preventDefault();

    // Wenn wir NICHT auf der Startseite sind
    if (location.pathname !== "/") {
      // Navigate zur Startseite
      window.location.href = "/";

      // Warten bis Seite gerendert ist
      setTimeout(() => scrollToSection(id), 200);

      setIsOpen(false);
      return;
    }

    // Wenn wir bereits auf der Startseite sind
    scrollToSection(id);
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">

        <img
          src={logo}
          alt="Stein & Wagner Logo"
          className="logo"
          onClick={(e) => handleScroll(e, "home")}
          style={{ cursor: "pointer" }}
        />

        {/* Desktop */}
        <ul className="nav-links">
          <li><a href="/#home" onClick={(e) => handleScroll(e, "home")}>Start</a></li>{/* remove */}
          <li><a href="/#services" onClick={(e) => handleScroll(e, "services")}>Leistungen</a></li> {/* remove */}
          <li><a href="/#about" onClick={(e) => handleScroll(e, "about")}>Über uns</a></li> {/* remove */}
          <li><a href="/#contact" onClick={(e) => handleScroll(e, "contact")}>Kontakt</a></li> {/* remove */}
        </ul>

        {/* Mobile */}
        <div className="nav-toggle" onClick={() => setIsOpen(!isOpen)}>
          <span></span><span></span><span></span>
        </div>
      </div>

      <ul className={`nav-links-mobile ${isOpen ? "active" : ""}`}>
        <li><a href="#home" onClick={(e) => handleScroll(e, "home")}>Start</a></li>
        <li><a href="#services" onClick={(e) => handleScroll(e, "services")}>Leistungen</a></li>
        <li><a href="#about" onClick={(e) => handleScroll(e, "about")}>Über uns</a></li>
        <li><a href="#contact" onClick={(e) => handleScroll(e, "contact")}>Kontakt</a></li>
      </ul>
    </nav>
  );
}
